var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 3.19995H3.20005C1.88005 3.19995 0.800049 4.27995 0.800049 5.59995V21.6C0.800049 22.92 1.88005 24 3.20005 24H12.144V26.5119H4.80005C4.36005 26.5119 4.00005 26.872 4.00005 27.3119C4.00005 27.7519 4.36005 28.1119 4.80005 28.1119H12.944C12.944 28.1119 12.944 28.1119 12.952 28.1119H19.056C19.056 28.1119 19.056 28.1119 19.064 28.1119H27.2C27.64 28.1119 28 27.7519 28 27.3119C28 26.872 27.64 26.5119 27.2 26.5119H19.856V24H28.8C30.12 24 31.2 22.92 31.2 21.6V5.59995C31.2 4.27995 30.12 3.19995 28.8 3.19995ZM13.744 26.5119V24.08H18.248V26.5119H13.744ZM3.20005 4.79995H28.8C29.24 4.79995 29.6 5.15995 29.6 5.59995V17.6559H2.40005V5.59995C2.40005 5.15995 2.76005 4.79995 3.20005 4.79995ZM28.8 22.4H3.20005C2.76005 22.4 2.40005 22.0399 2.40005 21.6V19.2559H29.6V21.6C29.6 22.0399 29.24 22.4 28.8 22.4Z",
    fill: "#353EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.e06708ede94fefec91b3c459dc4ecf87.svg";
export { ForwardRef as ReactComponent };